import React from 'react';
import ResizablePanels from 'resizable-panels-react';
import ViewCsv from './ViewCsv';
import ViewCode from './ViewCode';
import { Box, TextField, Typography } from '@material-ui/core';
import CsvDiff from './CsvDiff';
import CodeDiff from './CodeDiff';
import LoadingOverlay from 'react-loading-overlay';
import ScaleLoader from 'react-spinners/ScaleLoader';
import { AsyncPaginate } from 'react-select-async-paginate';
import ProjectService from '../../services/api/Project';
import constants, { APIRESPONSE } from '../../settings/shared/constants';
import service from '../../services/api/Common';
import moment from 'moment';
import ReactPaginate from 'react-paginate';
import '../../assets/css/catalog.css';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  InputGroup,
  InputGroupButtonDropdown
} from 'reactstrap';
import Storage from '../../services/api/Storage';
import RunService from '../../services/api/Run';
import Scrollbars from 'react-custom-scrollbars';
import SelectedCompare from './SelectedCompare';

let prevVersionedFiles = [];

export default class Catalog extends React.Component {
  constructor(props) {
    super(props);
    this.timeout =  0;
    let viewId = '';
    let filterBy = "";
    let path = window.location.search;
    if (path.includes('/project')) {
      let pathArray = window.location.pathname.split('?');
      viewId = pathArray
        .toString()
        .substring(pathArray.toString().lastIndexOf('/') + 1);
      filterBy = "Runs";
    } else {
      filterBy = "Projects";
    }

    this.state = {
      projectId: viewId,
      pageNumber: 0,
      catalog: {},
      selectedOutputFile: null,
      selectedOutputIpynbFile: null,
      arrayOfCheckboxSelectedFiles: [],
      loadCsvDiffComponent: false,
      loadCodeDiffComponent: false,
      selectedRunNamesCompare: [],
      chooseRunNameCompare: [],
      tableCompareDTO: [],
      outputsOfSelectedFiles: {},
      versionedFiles: [],
      selectedLabel: '',
      selectedSearchElements: this.props.selected || [],
      selectedAllProjectsRun: [],
      page: 1,
      defaultCheckedRadioButton: 0,
      totalPages: null,
      showPagination: false,
      searchBoxItemSelected: false,
      checkedRadoButton: null,
      dropdownOpen: false,
      filterBy: filterBy,
      value: '',
      allProjectsProjectDTOS: [],
      selectedProjectIds: [],
      likeSearchResponses: [],
      openComp: { open: false, divIndex: null },
      SelectedFilesVersionList: [],
      versionName : null,
      modelFilesFinal : [],
      selectedModelType: null,
      selectedModelFileName: null,
      newRunDetailsFiles : [],
      hideCatalog : false,
      swidth: window.innerWidth,
      sheight: window.innerHeight
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    if (this.state.projectId) {
      this.getLastRunData(this.state.projectId);
    } else {
      this.getLastRunData(undefined);
    }
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ swidth: window.innerWidth, sheight: window.innerHeight});
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props?.selected && prevProps?.selected
      && this.props.selected.length !== prevProps.selected.length) {
      this.handleChangeRunCompare(this.props.selected);
    }
  }

  getLikeSearchDataForProjectIds = async (
    ids,
    page,
    calledFirstTime = false
  ) => {
    this.setState({ loading: true });

    let data = {
      columnName: 'runStatus',
      columnValue: 'completed',
      projectIds: ids,
    };
    const response = await service({
      url: constants.api.run.GetRunbySearch + '?page=' + page + '&size=' + 15,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
      },
      data: data,
    });
    let searchList = await response.runDetails;
    if (calledFirstTime) {
      this.setState({ totalPages: response.totalPages });
    }
    this.renderData(searchList.content);
    return searchList;
  };

  //Get All Project
  getProjects = async () => {
    this.setState({ loading: true });
    let response = await ProjectService.GetProject(0, 20);
    let responseData = response.projectDTOSPage;

    if (responseData.content !== null) {
      // setting default selected item in search bar
      let defaultObj = [
        {
          label: responseData.content[0].name,
          id: responseData.content[0].id,
          value: responseData.content[0].id,
          name: responseData.content[0].name,
        },
      ];

      this.getLikeSearchDataForProjectIds(
        [responseData.content[0]?.id],
        0,
        true
      );
      this.setState({
        selectedAllProjectsRun: defaultObj,
        selectedProjectIds: [
          ...this.state.selectedProjectIds,
          responseData.content[0].id,
        ],
      });
    } else {
      this.setState({
        errorMessage: response.errorMessage,
        loading: false,
      });
    }
  };

  handleChangeProject = async (event) => {
    if (event === null && !this.state.projectId) {
     this.resetData();
     this.runDetailsProjectPageRecored();
    }
    this.setState({ selectedAllProjectsRun: event,modelFilesFinal :[],newRunDetailsFiles:[], arrayOfCheckboxSelectedFiles : []},()=>{
      if(event !== null){
        this.getNewRunsData();
     }
    });
  };

  handleRunsProjectPagination = (pageNumber) => {
    this.getLikeSearchDataForProjectIds(
      this.state.selectedProjectIds,
      pageNumber.selected
    );
    if (this.state.projectId) {
      this.getLastRunData(this.state.projectId);
    } else {
      this.getLastRunData(undefined);
    }
  };

  async loadOptions(search, prevOptions, { page, viewIds, selvalue }) {
    let filteredOptions;
    let options = [];
    let results = [];
    let removevalues = [];
    let checkedvalues = selvalue;
    if (!search) {
      filteredOptions = options;
    } else {
      const searchLower = search.toLowerCase();
      var runData = {};
      runData["jobIdOrNameStartsWith"] = searchLower
      runData["projectIds"] = viewIds
      runData["runStatus"] = "Completed"
      const response =  await RunService.getRunSearch(runData, page, 20);
      let searchList = await response.runDetails.content !== null && await response.runDetails.content.length > 0 ? await response.runDetails.content : [];
      searchList.map((item, index) => {
          results.push({
            label: item.name + ' _ ' + item.jobId,
            jobId: item.jobId,
            id: item.id,
            description: item.description,
            value: item.runId,
            runDbId: item.id,
            createdDate: item.createdDate,
            input: item.inputSourceFiles,
            code: item.codeSourceFiles,
            modelInput: item.modelInputFiles,
            modelCodeFiles: item.modelCodeFiles,
            output: item.modelOutputFiles,
            modalcode: item.modelOutputCodeFiles,
            parameter: item.parameterSet,
            runTime: item.runTime,
            runBy: item.createdBy,
            logEntry: item.logFiles,
            masterJobId: item.masterJobId,
            name: item.name,
          });
      });

      const filterByReference = (results, checkedvalues) => {
        let res = [];
        res = results?.filter((el) => {
          return !checkedvalues?.find((element) => {
            return element?.jobId === el.jobId;
          });
        });
        return res;
      };

      removevalues = filterByReference(results, checkedvalues);

      filteredOptions = removevalues.filter(({ label }) =>
        label.toLowerCase().includes(searchLower)
      );
    }
    const hasMore = filteredOptions.length > prevOptions.length + 10;
    const slicedOptions = filteredOptions.slice(
      prevOptions.length,
      prevOptions.length + 10
    );

    return {
      options: slicedOptions,
      hasMore,
      additional: {
        page: page + 1,
        viewIds: viewIds,
        selvalue: selvalue,
      },
    };
  }

  async loadOptionsForAllProjects(
    search,
    prevOptions,
    { page, viewId, selvalue }
  ) {
    let filteredOptions;
    let options = [];
    let results = [];
    let removevalues = [];
    let checkedvalues = selvalue;
    if (!search) {
      filteredOptions = options;
    } else {
      const searchLower = search.toLowerCase();

      const response = await ProjectService.GetAutoCompleteResult(
        'project',
        searchLower
      );

      let responseData = await response.projectDTOSPage;

      let searchList = await responseData.content;

      searchList.map((item, index) => {
        results.push({
          label: item.name,
          id: item.id,
          value: item.id,
          name: item.name,
        });
      });

      const filterByReference = (results, checkedvalues) => {
        let res = [];
        res = results?.filter((el) => {
          return !checkedvalues?.find((element) => {
            return element?.id === el?.id;
          });
        });
        return res;
      };

      removevalues = filterByReference(results, checkedvalues);

      filteredOptions = removevalues.filter(({ label }) =>
        label.toLowerCase().includes(searchLower)
      );
    }
    const hasMore = filteredOptions.length > prevOptions.length + 10;
    const slicedOptions = filteredOptions.slice(
      prevOptions.length,
      prevOptions.length + 10
    );

    return {
      options: slicedOptions,
      hasMore,
      additional: {
        page: page + 1,
        viewId: viewId,
        selvalue: selvalue,
      },
    };
  }

  resetData = () =>{
    this.setState({
      selectedModelType: null,
      selectedModelFileName : null,
      selectedOutputFile : null,
      selectedOutputIpynbFile: null,
      newRunDetailsFiles : [],
      selectedLabel : "",
      arrayOfCheckboxSelectedFiles : [],
      modelFilesFinal : [],
      openComp : {}
    })
  }

  handleChangeRunCompare = (event) => {
    if (event === null && this.state.projectId) {
      this.resetData();
      this.runDetailsProjectPageRecored();
    } else if (event === null && !this.state.projectId) {
     this.resetData();
     this.runDetailsProjectPageRecored();
    }
    this.setState({ searchBoxItemSelected: true });
    this.setState({ selectedSearchElements: event,modelFilesFinal :[],newRunDetailsFiles:[],arrayOfCheckboxSelectedFiles : []},()=>{
      if(event !== null){
        this.getNewRunsData();
     }
    });
  };

  formRenderObject = (renderObj, innerItem, item) => {
    let key =
      innerItem.indexOf('INPUT:') == -1
        ? this.getKeyName(innerItem)
        : 'INPUT:' + this.getKeyName(innerItem);
    let value = {
      jobId: item.jobId,
      jobName: item.name,
      createdDate: item.endTime,
      fileName: innerItem.replace('INPUT:', ''),
    };
    if (renderObj[key] == undefined) renderObj[key] = [value];
    else renderObj[key].push(value);
    return renderObj;
  };
  getKeyName = (innerItem) => {
    return innerItem.indexOf('/') == -1
      ? innerItem.replace('INPUT:', '')
      : innerItem.substring(innerItem.lastIndexOf('/') + 1);
  };

  setRenderObject = (obj) => {
    const csvKeys = [];
    const ipynpKeys = [];
    const inputCsvKeys = [];
    const inputIpynpKeys = [];

    for (const key in obj) {
      if (key.indexOf('INPUT:') != -1) {
        if (key.endsWith('.csv')) {
          inputCsvKeys.push(key);
        } else if (key.endsWith('.ipynb')) {
          inputIpynpKeys.push(key);
        }
      } else if (key.endsWith('.csv')) {
        csvKeys.push(key);
      } else if (key.endsWith('.ipynb')) {
        ipynpKeys.push(key);
      }
    }
    this.setState(
      {
        outputsOfSelectedFiles: obj,
        catalog: {
          csvOutputFiles: csvKeys,
          ipynbOutputFiles: ipynpKeys,
          csvInputFiles: inputCsvKeys,
          ipynbInputFiles: inputIpynpKeys,
        },
        loading: false,
      },
      () => {
        if (this.state.checkedRadoButton) {
          this.getVersionedFiles(this.state.checkedRadoButton);
        } else {
          this.getVersionedFiles(this.state.catalog?.csvOutputFiles[0]);
        }
      }
    );
  };

  getRunsData = async (id, calledFirstTime, page) => {
    this.setState({ loading: true });
    this.getLikeSearchDataForProjectIds([id], page, calledFirstTime);
  };

  renderData = (runSDTO) => {
    let renderObj = {};
    runSDTO.forEach((run, index) => {
      run?.modelOutputFiles?.forEach((outputFile) => {
        if (outputFile !== undefined) {
          var result = outputFile.split("/").pop();
          this.constructModelFiles("modelOutputFiles", result, outputFile);
        }
      });

      run?.modelOutputCodeFiles?.forEach((innerItem) => {
        var result = innerItem.split("/").pop();
        this.constructModelFiles("modelOutputCodeFiles", result, innerItem);
      });

      run?.modelInputFiles?.forEach((innerItem) => {
        var result = innerItem.split("/").pop();
        this.constructModelFiles("modelInputFiles", result, innerItem);
      });

      run?.modelCodeFiles?.forEach((innerItem) => {
        var result = innerItem.split("/").pop();
        this.constructModelFiles("modelCodeFiles", result, innerItem);
      });
      if (runSDTO.length - 1) {
        this.setState({ loading: false })
      }
    });
  };


  constructModelFiles = (modalType, fName, fPath) => {
    let renderObj = {
      type: modalType,
      fileName: fName,
      filePath: fPath
    }
    var foundFlag = this.state.modelFilesFinal.some(el => el.type === modalType && el.fileName === fName);
    if (!foundFlag) {
      this.setState({
        modelFilesFinal: [...this.state.modelFilesFinal, renderObj]
      })
    }
  }

  selectCheckboxOutputFile = (outputFile, version, index) => {
    let filterFile = [];
    if(version){
      this.setState({
        versionName : outputFile.substring(
          outputFile.lastIndexOf('/') + 1
        )
      },()=>{
        filterFile.push(outputFile.substring(0, outputFile.lastIndexOf("/") ));
      })
    }else{
      filterFile =  this.getFilePath(outputFile[this.state.selectedModelType]);
      this.setState({
        versionName : null
      })
    }
      if (this.state.selectedModelFileName.includes('.csv')) {
      this.setState(
        {
          selectedOutputFile: null,
          selectedOutputIpynbFile: null,
          selectedLabel: !version ? `${index}_${outputFile.name}` : `${index}_${outputFile}`,
        },
        () => {
          this.setState({ selectedOutputFile: filterFile.length > 0 ?filterFile[0] : null });
        }
      );
      return;
    } else if (this.state.selectedModelFileName.includes('.ipynb')) {
      this.setState(
        {
          selectedOutputFile: null,
          selectedOutputIpynbFile: null,
          selectedLabel: !version ? `${index}_${outputFile.name}` : `${index}_${outputFile}`,
        },
        () => {
          this.setState({ selectedOutputIpynbFile: filterFile.length > 0 ?filterFile[0] : null });
        }
      );
      return;
    }
  };


  getFilePath = (parseValue) =>{
    return parseValue !== undefined && parseValue !== null && parseValue.length > 0  && parseValue.filter(item => item.includes(this.state.selectedModelFileName));
  }
  //onChange for checkbox csv selected files
  onCheckboxSelectionFileChange = (index, version, outputItem) => {
    let file = "";
    if(version){
      file = index + "_" + outputItem
    }else{
      let parseValue = this.getFilePath(outputItem[this.state.selectedModelType]);
      file = index + "_" + parseValue[0];
    }
    if (this.state.arrayOfCheckboxSelectedFiles?.length >= 1) {
      let extension = '';
      if (file.includes('.ipynb')) {
        extension = 'ipynb';
      } else {
        extension = 'csv';
      }
      if (!this.state?.arrayOfCheckboxSelectedFiles[0]?.includes(extension)) {
        return;
      }
    }

    if (this.state.arrayOfCheckboxSelectedFiles.includes(file)) {
      let filteredArray = this.state.arrayOfCheckboxSelectedFiles?.filter(
        (fileName) => {
          return fileName !== file;
        }
      );
      this.setState({ arrayOfCheckboxSelectedFiles: filteredArray });
      return;
    }

    if (this.state.arrayOfCheckboxSelectedFiles?.length >= 2) {
      this.state.arrayOfCheckboxSelectedFiles[1] = file;
      this.setState({
        arrayOfCheckboxSelectedFiles: this.state?.arrayOfCheckboxSelectedFiles,
      });
    } else {
      let { arrayOfCheckboxSelectedFiles } = this.state;
      arrayOfCheckboxSelectedFiles.push(file);
      this.setState({
        arrayOfCheckboxSelectedFiles: arrayOfCheckboxSelectedFiles,
      });
    }
  };

  checkBothFiles = () => {
    this.state.arrayOfCheckboxSelectedFiles?.every((file) => {
      return file.includes('.csv')
        ? this.setState({ loadCsvDiffComponent: true })
        : file.includes('.ipynb')
          ? this.setState({ loadCodeDiffComponent: true })
          : null;
    });
  };


  getLastRunData = (projectId) => {
    var runData = {};
    let projectIds = [];
    this.setState({
      loading: true
    })
    runData["runStatus"] = "Completed";
    if (projectId !== undefined) {
      runData["projectIds"] = [projectId]
    } else {
      if (this.state.filterBy === "Projects") {
        this.state.selectedAllProjectsRun?.forEach((project) => {
          projectIds.push(project.masterJobId !== undefined ? project.masterJobId : project.value);
          runData["projectIds"] = projectIds
        });
      } else {
        this.state.selectedSearchElements?.forEach((runs) => {
          projectIds.push(runs.jobId);
          runData["jobIds"] = projectIds
        });
      }
    }
    if (projectId === undefined) {
      RunService.getRunSearch(runData, 0, 1).then((response) => {
        if(response !== null && response !== undefined){
          if (response.status === APIRESPONSE.SUCCESS) {
            let responseData = response.runDetails.content;
            if (responseData !== null && responseData.length > 0) {
              this.renderData(responseData)
              let contentData = responseData[0];
              this.setState({
                hideCatalog: false
              }, () => {
                this.getProjectsName(responseData[0].masterJobId, contentData);
              })
            } else {
              this.setState({
                loading: false
              })
            }
          } else {
            this.setState({ loading: false, hideCatalog: true })
          }
        }else{
          this.setState({ loading: false, hideCatalog: true })
        }
      }).catch((error) => {
        this.setState({
          loading: false
        })
      })
    } else {
      this.runDetailsProjectPageRecored();
    }
  }

  runDetailsProjectPageRecored = () => {  // If No projects filltering call default project history
    let runData = {};
    this.setState({
      loading: true
    })
    if (this.state.projectId !== "") {
      runData["projectIds"] = [this.state.projectId]
    }
    runData["runStatus"] = "Completed";
    RunService.getRunSearch(runData, 0, 15).then((response) => {
      if (response !== null && response !== undefined) {
        if (response.status === APIRESPONSE.SUCCESS) {
          let responseData = response.runDetails.content;
          if (responseData !== null && responseData.length > 0) {
            this.renderData(responseData)
            this.modelFilesDefaultSelection();

          } else {
            this.setState({
              loading: false, hideCatalog: true
            })
          }
        } else {
          this.setState({
            loading: false
          })
        }
      } else {
        this.setState({ loading: false, hideCatalog: true })
      }
    }).catch((error) => {
      this.setState({
        loading: false
      })
    })
  }

  getProjectsName = async (masterId, contentData) => {
    this.setState({
      loading : true
    })
    let response = await ProjectService.GetProjectById(masterId);
    let rData = response.projectDTOS;
    if (rData !== null && rData.length > 0) {
      let data = rData[0];
      if (this.state.filterBy === "Runs") {
        contentData["label"] = data.name + ' _ ' + contentData.jobId;
        this.setState({
          selectedSearchElements: [contentData]
        },()=>{
          this.modelFilesDefaultSelection();
        })
      } else {
        contentData["label"] = data.name;
        this.setState({
          selectedAllProjectsRun: [contentData]
        },()=>{
          this.modelFilesDefaultSelection();
        })
      }
    }
  };
 
  getRunFiles = (page) =>{
    this.setState({
      loading : true
    })
    let searchKey = this.getModelKeyFile(this.state.selectedModelType);
    let projectIds = [];
    var runData = {};
    if(this.state.filterBy === "Projects"){
      this.state.selectedAllProjectsRun?.forEach((project) => {
        projectIds.push(project.masterJobId !== undefined ? project.masterJobId : project.value);
        runData["projectIds"] = projectIds
    });
    }else{
      this.state.selectedSearchElements?.forEach((runs) => {
        projectIds.push(runs.jobId);
        runData["jobIds"] = projectIds
    });
    }
    runData[searchKey] = this.state.selectedModelFileName;
    runData["runStatus"] =  "Completed";
    this.getRunBySearchKey(runData, page)
  }
  getRunBySearchKey = (data, page) =>{
     let size  = 15
    RunService.getRunSearch(data, page, size).then((response) =>{
      if (response !== null && response !== undefined) {
      if(response.status === APIRESPONSE.SUCCESS){
       this.setState({
        newRunDetailsFiles : response.runDetails.content,
        totalPages : response.runDetails.totalPages,
        loading :false
       })
      }else{
        this.setState({
          loading : false
        })
      }
    } else {
      this.setState({ loading: false})
    }
    }).catch((error) => {
      this.setState({
        loading : false
      })
    })

  }

  getModelKeyFile = (keyName) => {
    switch (keyName !== undefined) {
      case keyName === "modelCodeFiles":
        return "modelCodeFileEndsWith"
      case keyName === "modelInputFiles":
        return "modelInputFileEndsWith";
      case keyName === "modelOutputFiles":
        return "modelOutputFileEndsWith";
      case keyName === "modelOutputCodeFiles":
        return "modelOutputCodeFileEndsWith";
      default:
        return "";
    }
  }

  getNewRunsData = () => {
    var runData = {};
    let jobIds = [];
    let projectIds = [];
    if(this.state.filterBy === "Projects"){
      this.state.selectedAllProjectsRun?.forEach((runs) => {
        projectIds.push((runs.masterJobId !== undefined && runs.masterJobId !== null) ? runs.masterJobId : runs.value);
        runData["projectIds"] = projectIds
      });
    }else{
      this.state.selectedSearchElements?.forEach((runs) => {
       jobIds.push(runs.jobId);
       runData["jobIds"] = jobIds
      });
    }
    runData["runStatus"] = "Completed";
    RunService.getRunSearch(runData, 0, 15).then((response) => {
      if (response !== null && response !== undefined) {
        if (response.status === APIRESPONSE.SUCCESS) {
          if (response.runDetails.content !== null && response.runDetails.content.length > 0) {
            this.renderData(response.runDetails.content)
            this.modelFilesDefaultSelection();
          }
        }
      }else{
        this.setState({loading : false})
      }
    }).catch((error) => {
      this.setState({loading : false})
    })
  }

  getVersionedFiles = (selectedFile) => {
    if (selectedFile && this.state.outputsOfSelectedFiles[selectedFile] !== undefined) {
      // setting this variable to use in handleSearchOnchange func
      prevVersionedFiles = [
        ...this.state?.outputsOfSelectedFiles[selectedFile],
      ];
      this.setState({
        defaultCheckedRadioButton: 0,
        showPagination: this.state.searchBoxItemSelected ? false : true,
        versionedFiles: [...this.state?.outputsOfSelectedFiles[selectedFile]],
        loading: false,
      });
    }else{
      this.setState({
        defaultCheckedRadioButton: 0,
        showPagination: this.state.searchBoxItemSelected ? false : true,
        loading: false,
      });
    }
  };

  searchFilesByJobIdOrName = (searchKey) => {
    let runData = {};
    let projectIds = [];
    let jobIds = [];
    if (this.state.filterBy === "Projects") {
      this.state.selectedAllProjectsRun?.forEach((runs) => {
        projectIds.push((runs.masterJobId !== undefined && runs.masterJobId !== null) ? runs.masterJobId : runs.value);
        runData["projectIds"] = projectIds
      });
    } else {
      if(this.state.projectId){
        runData["projectIds"] = [this.state.projectId]
      }else{
        this.state.selectedSearchElements?.forEach((runs) => {
          jobIds.push(runs.jobId);
          runData["jobIds"] = jobIds
        });
      }
    }
    runData["runStatus"] = "Completed";
    runData["jobIdOrNameStartsWith"] = searchKey
    this.getRunBySearchKey(runData, 0);
  }

  handleSearchOnchange = (event) => {
    var searchText = event.target.value; // this is the search text
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      if (searchText === "") {
        if (this.state.modelFilesFinal !== undefined && this.state.modelFilesFinal.length > 0) {
          this.getRunFiles(0);
        }
      } else {
        this.searchFilesByJobIdOrName(searchText);
      }
    }, 1000);
  };

  handlePageClick = (pageNumber) => {
    this.getRunFiles(pageNumber.selected);
  };

  toggleDropDown = () => {
    this.setState({
      dropdownOpen: !this.state?.dropdownOpen,
    });
  };

  searchBy = (value) => {
    this.setState({
      filterBy: value,
      value: '',
      selectedModelType: null,
      selectedModelFileName: null,
      selectedOutputFile: null,
      selectedOutputIpynbFile: null,
      newRunDetailsFiles: [],
      selectedLabel: "",
      modelFilesFinal: [],
      selectedSearchElements: [],
      selectedAllProjectsRun: [],
      arrayOfCheckboxSelectedFiles : [],
      openComp : {}
    }, () => {
      if (this.state.projectId) {
        this.getLastRunData(this.state.projectId);
      } else {
        this.getLastRunData(undefined);
      }
    });
  };

  getFilesVersionsList = async (index, outputFile) => {
    let filterFile = this.getFilePath(outputFile[this.state.selectedModelType]);
    let response = await Storage.getObjectVersion(filterFile.length > 0 ?filterFile[0] : null);
    this.setState({
      openComp: {
        open: true,
        divIndex: `${index}_${outputFile.name}`,
      },
      SelectedFilesVersionList: response.result,
    });
  };

  modelFilesCheckbox = (type, fileName) =>{
    document.getElementById(type+ fileName).click();
    this.setState({
      selectedModelType: type,
      selectedModelFileName : fileName,
      selectedOutputFile : null,
      selectedOutputIpynbFile: null,
      newRunDetailsFiles : [],
      arrayOfCheckboxSelectedFiles : [],
      selectedLabel : "",
      openComp : {}
    },()=>{
      this.getRunFiles(0);
    });
  }

  modelFilesDefaultSelection = () =>{
      if(this.state.modelFilesFinal !== null && this.state.modelFilesFinal.length > 0){
        let data = [];
        if(this.state.modelFilesFinal.filter(item => item.type === "modelOutputFiles").length > 0){
           data = this.state.modelFilesFinal.filter(item => item.type === "modelOutputFiles");
        }else if(this.state.modelFilesFinal.filter(item => item.type === "modelOutputCodeFiles").length > 0){
          data = this.state.modelFilesFinal.filter(item => item.type === "modelOutputCodeFiles");
        }else if(this.state.modelFilesFinal.filter(item => item.type === "modelInputFiles").length > 0){
          data = this.state.modelFilesFinal.filter(item => item.type === "modelInputFiles");
        }else if(this.state.modelFilesFinal.filter(item => item.type === "modelCodeFiles").length > 0){
          data = this.state.modelFilesFinal.filter(item => item.type === "modelCodeFiles");
        }
        this.modelFilesCheckbox(data[0].type, data[0].fileName);
        this.setState({
          loading : false
        })
      }
  }

  render() {
    return (
      <>
        <LoadingOverlay
          active={this.state.loading}
          spinner={
            <ScaleLoader
              height={35}
              width={5}
              radius={2}
              margin={2}
              color={'#123abc'}
              loading={this.state.loading}
            />
          }
        >

          <div className='catalog-main-body'>
           {!this.state.hideCatalog && <ResizablePanels
              displayDirection='row'
              width='100%'
              height='78vh'
              panelsSize={[30, 30, 40]}
              sizeUnitMeasure='%'
              resizerColor='#D6D7DA'
              resizerSize='3px'
            >
              <div className='asyncpaginate-main-div'>
                {this.state.projectId ? (
                  <AsyncPaginate
                    isMulti
                    closeMenuOnSelect={false}
                    placeholder='Search by Run Name or JobID'
                    value={this.state.selectedSearchElements}
                    loadOptions={this.loadOptions}
                    onChange={this.handleChangeRunCompare}
                    additional={{
                      page: 0,
                      viewIds: [this.state.projectId],
                      selvalue: this.state.selectedRunNamesCompare,
                    }}
                  />
                ) : (
                  <div className='dropdown-wrapper-div'>
                    {/* only showing dropdown when project id is not available in location */}
                    <div className='dropdown-parent-div'>
                      <InputGroup className='prosrch'>
                        <InputGroupButtonDropdown
                          addonType='append'
                          isOpen={this.state.dropdownOpen}
                          toggle={this.toggleDropDown}
                        >
                          <DropdownToggle caret>
                            {this.state.filterBy}
                          </DropdownToggle>
                          <DropdownMenu>
                            <DropdownItem
                              onClick={(e) => this.searchBy('Projects')}
                            >
                              Projects &nbsp;
                            </DropdownItem>
                            <DropdownItem divider />
                            <DropdownItem
                              onClick={(e) => this.searchBy('Runs')}
                            >
                              Runs &nbsp;
                            </DropdownItem>
                          </DropdownMenu>
                        </InputGroupButtonDropdown>
                      </InputGroup>
                    </div>
                    {this.state.filterBy === 'Runs' ? ( 
                      <div
                        className='asyncpaginate-wrappper-div'
                        key={this.state.filterBy}
                      >
                        <AsyncPaginate
                          isMulti
                          closeMenuOnSelect={false}
                          placeholder='Search by Run Name or JobID'
                          value={this.state.selectedSearchElements}
                          loadOptions={this.loadOptions}
                          onChange={this.handleChangeRunCompare}
                          additional={{
                            page: 0,
                            viewIds: this.state.selectedProjectIds,

                            selvalue: this.state.selectedRunNamesCompare,
                          }}
                        />
                      </div>
                    ) : (
                      <div
                        className='asyncpaginate-wrappper-div'
                        key={this.state.filterBy}
                      >
                        <AsyncPaginate
                          isMulti
                          closeMenuOnSelect={false}
                          placeholder='Search by Project Name'
                          value={this.state.selectedAllProjectsRun}
                          loadOptions={this.loadOptionsForAllProjects}
                          onChange={this.handleChangeProject}
                          additional={{
                            page: 0,
                            selvalue: this.state.selectedRunNamesCompare,
                          }}
                        />
                      </div>
                    )}
                  </div>
                )}

                <br />
                {this.state.modelFilesFinal.length > 0 && <div>
                <p>
                  <b>Model Output Files :</b>
                </p>
                {this.state.modelFilesFinal.filter(item => item.type === "modelOutputFiles").map((inputFile, index) => {
                  return (
                    <div key={index} className='custom-control custom-radio'>
                      <input
                        type='radio'
                        className='custom-control-input'
                        id={inputFile.type + inputFile.fileName}
                        name='defaultExampleRadios'
                        onClick={() => this.modelFilesCheckbox(inputFile.type, inputFile.fileName)
                        }
                      />
                      <label
                        className='custom-control-label text-primary'
                        htmlFor={inputFile.type + inputFile.fileName}
                      >
                        {inputFile.fileName}
                      </label>
                    </div>
                  );
                })}
                <br />

                <p>
                  <b>Model Output Code Files :</b>
                </p>
                {this.state.modelFilesFinal.filter(item => item.type === "modelOutputCodeFiles").map((inputFile, index) => {
                  return (
                    <div key={index} className='custom-control custom-radio'>
                      <input
                        type='radio'
                        className='custom-control-input'
                        id={inputFile.type + inputFile.fileName}
                        name='defaultExampleRadios'
                        onClick={() => {
                          this.setState({
                            selectedModelType: inputFile.type,
                            selectedModelFileName : inputFile.fileName,
                            selectedOutputFile : null,
                            newRunDetailsFiles : [],
                            selectedOutputIpynbFile: null,
                            arrayOfCheckboxSelectedFiles : [],
                            selectedLabel : "",
                            openComp : {}
                          },()=>{
                            this.getRunFiles(0);

                          });
                        }}
                      />
                      <label
                        className='custom-control-label text-primary'
                        htmlFor={inputFile.type + inputFile.fileName}
                      >
                        {inputFile.fileName}
                      </label>
                    </div>
                  );
                })}
                <br />

                <p>
                  <b>Model Input Files :</b>
                </p>
                {this.state.modelFilesFinal.filter(item => item.type === "modelInputFiles").map((inputFile, index) => {
                  return (
                    <div key={index} className='custom-control custom-radio'>
                      <input
                        type='radio'
                        className='custom-control-input'
                        id={inputFile.type + inputFile.fileName}
                        name='defaultExampleRadios'
                        onClick={() => {
                          this.setState({
                            selectedModelType: inputFile.type,
                            selectedModelFileName : inputFile.fileName,
                            selectedOutputFile : null,
                            newRunDetailsFiles : [],
                            selectedOutputIpynbFile: null,
                            arrayOfCheckboxSelectedFiles : [],
                            selectedLabel : "",
                            openComp : {}
                          },()=>{
                            this.getRunFiles(0);

                          });
                        }}
                      />
                      <label
                        className='custom-control-label text-primary'
                        htmlFor={inputFile.type + inputFile.fileName}
                      >
                        {inputFile.fileName}
                      </label>
                    </div>
                  );
                })}
                <br />

                <p>
                  <b>Model Code Files :</b>
                </p>
                {this.state.modelFilesFinal.filter(item => item.type === "modelCodeFiles").map((inputFile, index) => {
                  return (
                    <div key={index} className='custom-control custom-radio'>
                      <input
                        type='radio'
                        className='custom-control-input'
                        id={inputFile.type + inputFile.fileName}
                        name='defaultExampleRadios'
                        onClick={() => {
                          this.setState({
                            selectedModelType: inputFile.type,
                            selectedModelFileName : inputFile.fileName,
                            selectedOutputFile : null,
                            newRunDetailsFiles : [],
                            selectedOutputIpynbFile: null,
                            selectedLabel : "",
                            arrayOfCheckboxSelectedFiles : [],
                            openComp : {}
                          },()=>{
                            this.getRunFiles(0);
                          });
                        }}
                      />
                      <label
                        className='custom-control-label text-primary'
                        htmlFor={inputFile.type + inputFile.fileName}
                      >
                        {inputFile.fileName}
                      </label>
                    </div>
                  );
                })}
                </div>}
                <br />
              </div>


                <div className='ml-1'>
                <TextField
                  variant='outlined'
                  type='search'
                  placeholder='Search File Runs'
                  size='small'
                  className="middle-section-search"
                  onChange={this.handleSearchOnchange}
                />
                <br />
                {this.state.newRunDetailsFiles?.length > 0 ? (
                <>
                {/* Here calls the Selected list component loaded*/}
                <SelectedCompare 
                 arrayOfCheckboxSelectedFiles = {this.state.arrayOfCheckboxSelectedFiles}
                 checkBothFiles={this.checkBothFiles.bind(this)}/>
                  </>
                 ) : ""}

                 <Scrollbars autoHeight autoHeightMin={this.state.projectId ? 
                   this.state.arrayOfCheckboxSelectedFiles.length > 0 ? this.state.sheight - 330 : this.state.sheight - 300 
                  : this.state.arrayOfCheckboxSelectedFiles.length > 0 ? this.state.sheight - 300 : this.state.sheight - 220} className="middle-section mt-2">
                {this.state.newRunDetailsFiles !== null && this.state.newRunDetailsFiles.length === 0 ? <div className='d-flex justify-content-center'>
                  <span>No Run Details</span></div> : this.state.newRunDetailsFiles !== null && this.state.newRunDetailsFiles.length > 0 && 
                  this.state.newRunDetailsFiles.map((outputFile, index) => {
                  return (
                    <>
                      <div
                        key={`csv_${index}`}
                        title="Select 2 files to compare"
                        className='custom-control custom-checkbox'
                      >
                       <input
                          type='checkbox'
                          className='custom-control-input'
                          id={`csv_${index}`}
                          checked={this.state.arrayOfCheckboxSelectedFiles.includes(
                            `${index}_${this.getFilePath(outputFile[this.state.selectedModelType])}`
                          )}
                          onChange={(event) =>
                            this.onCheckboxSelectionFileChange(index, false, outputFile)
                          }
                        />
                        <label
                          className='custom-control-label'
                          htmlFor={`csv_${index}`}
                        ></label>
                        <span
                          className='actionicon'
                          onClick={(event) => {
                            this.selectCheckboxOutputFile(
                              outputFile,
                              false,
                              index
                            );
                            this.getFilesVersionsList(
                              index,
                              outputFile
                            );
                          }}
                          style={{
                            color:
                              this.state.selectedLabel ===
                                `${index}_${outputFile.name}`
                                ? 'skyblue'
                                : null,
                          }}
                        >   {`${outputFile?.jobId}_${outputFile?.name}`}
                
                        </span>
                        <br />
                        <span className='date-span'>
                          {outputFile.createdDate !== null
                            ? moment
                              .utc(outputFile.createdDate)
                              .local()
                              .format('MMM DD, YYYY hh:mm A')
                            : ''}
                        </span>
                      </div>
                      {this.state.openComp.open &&
                        `${index}_${outputFile.name}` ===
                        this.state.openComp.divIndex ? (
                        <>
                          {this.state.SelectedFilesVersionList.length > 0 ? (
                            <>
                              {this.state.SelectedFilesVersionList?.map(
                                (item, index) => {
                                  return (
                                    <div
                                      key={`ipynb_${item.name}`}
                                      className='custom-control custom-checkbox'
                                      style={{
                                        marginLeft: '10px',
                                        backgroundColor:
                                          index % 2 === 0
                                            ? '#f3f0f0'
                                            : '#f0f3f3',
                                      }}
                                    >
                                      <input
                                        type='checkbox'
                                        className='custom-control-input'
                                        id={`ipynb_${item.name}`}
                                        checked={this.state.arrayOfCheckboxSelectedFiles.includes(
                                          `${index}_${item?.name}`
                                        )}
                                        onChange={(event) =>
                                          this.onCheckboxSelectionFileChange(
                                            index, true, item?.name
                                          )
                                        }
                                      />
                                      <label
                                        className='custom-control-label'
                                        htmlFor={`ipynb_${item.name}`}
                                      ></label>
                                  
                                      {`${item?.file_name}` === "original" ? <span
                                        className='actionicon'
                                        onClick={(event) => {
                                          this.selectCheckboxOutputFile(
                                            item.name,
                                            true,
                                            index
                                          );
                                        }}
                                        style={{
                                          color:
                                            this.state.selectedLabel ===
                                              `${index}_${item.name}`
                                              ? 'skyblue'
                                              : "#4285F4",
                                          fontSize: '14px',
                                        }}
                                      > <b>Original</b> </span> :  <span className='versioned-date-span'>
                                        {item?.created !== null
                                          ? moment
                                            .utc(item?.created)
                                            .local()
                                            .format('MMM DD, YYYY hh:mm A')
                                          : ''}
                                          <br />

                                      </span> }
                                      {`${item?.file_name}` !== "original"  &&
                                      <span
                                        className='actionicon'
                                        onClick={(event) => {
                                          this.selectCheckboxOutputFile(
                                            item.name,
                                            true,
                                            index
                                          );
                                        }}
                                        style={{
                                          color:
                                            this.state.selectedLabel ===
                                              `${index}_${item.name}`
                                              ? 'skyblue'
                                              : null,
                                          fontSize: '14px',
                                        }}
                                      >
                                 {`${item?.name.substring(
                                          0,
                                          item.name.lastIndexOf('/')
                                        )}`}
                                 </span> }
                                     
                                      <br />
                                    </div>
                                  );
                                }
                              )}
                            </>
                          ) : (
                            <Typography
                              variant='body2'
                              className='no-version-present'
                            >
                              No versions present
                            </Typography>
                          )}
                        </>
                      ) : null}
                    </>
                  )
                })}

                <br />
                <div className='catalog_footer'>
                {this.state.filterBy === "Projects" && this.state.newRunDetailsFiles.length > 0 &&
                <>
                <div className='mt-3'>
                  <ReactPaginate
                    previousLabel={<i className='fa fa-angle-double-left' />}
                    nextLabel={<i className='fa fa-angle-double-right' />}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={this.state.totalPages}
                    onPageChange={(e) => this.handlePageClick(e)}
                    containerClassName={'pagination'}
                    subContainerClassName={'pages pagination'}
                    activeClassName='active'
                    pageClassName='liPaginate'
                    previousClassName='preStyle'
                    nextClassName='nexStyle'
                  />
                </div>
                </>
                }
                {this.state.filterBy === "Runs" && this.state.newRunDetailsFiles.length > 0 &&
                <>
                <div className='mt-3'>
                  <ReactPaginate
                    previousLabel={<i className='fa fa-angle-double-left' />}
                    nextLabel={<i className='fa fa-angle-double-right' />}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={this.state.totalPages}
                    onPageChange={(e) => this.handlePageClick(e)}
                    containerClassName={'pagination'}
                    subContainerClassName={'pages pagination'}
                    activeClassName='active'
                    pageClassName='liPaginate'
                    previousClassName='preStyle'
                    nextClassName='nexStyle'
                  />
                </div>
                </>
                }
                </div>
                </Scrollbars>
              </div>
              {/* middle end */}
              <div className='third-section-div'>
                {this.state.selectedOutputFile ? (
                  <ViewCsv
                    versionName = {this.state.versionName}
                    fileName={this.state.selectedOutputFile}
                    projectId={this.state.projectId}
                  />
                ) : null}
                {this.state.selectedOutputIpynbFile ? (
                  <ViewCode fileName={this.state.selectedOutputIpynbFile} />
                ) : null}
              </div>
            </ResizablePanels>}
            {this.state.hideCatalog && <div className='d-flex justify-content-center p-4'><span>No Completed Jobs</span></div>}
          </div>
          {this.state.loadCsvDiffComponent ? (
            <CsvDiff
              selectedFiles={this.state.arrayOfCheckboxSelectedFiles}
              openDiaog={this.state.loadCsvDiffComponent}
              closeDialog={() => {
                this.setState({ loadCsvDiffComponent: false });
              }}
            />
          ) : null}

          {this.state.loadCodeDiffComponent ? (
            <CodeDiff
              selectedFiles={this.state.arrayOfCheckboxSelectedFiles}
              openDiaog={this.state.loadCodeDiffComponent}
              closeDialog={() => {
                this.setState({ loadCodeDiffComponent: false });
              }}
            />
          ) : null}
        </LoadingOverlay>
      </>
    );
  }
}
